import { useEffect } from 'react';
import { useAssistantModel } from './useAssistantModel';
import { useAssistantFacade } from './useAssistantFacade';
import { useReadableEventRefresher } from '@zdrbm/zdr-react';

export function useEnsureConversation(conversationId: string) {
    const model = useAssistantModel();
    const facade = useAssistantFacade();
    const loadingState = facade.getConversationLoadingState(conversationId);

    const [[state]] = useReadableEventRefresher(loadingState);

    useEffect(() => {
        facade.ensureConversation(conversationId);
    }, [facade, conversationId]);

    return {
        conversation: model.getConversation(conversationId),
        loadingState: state,
    };
}
